/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";


export const APPLICATION_ROUTER:APPLICATION_ROUTER_INTERFACE = {
    COMMON: {
        HOME: {URL: "/"}
    },
    NOT_AUTHENTICATED: {
        REGISTER: {URL: "/rejestracja"},
        LOGIN: {URL: "/logowanie"},
        PASSWORD_RESET: {URL: "/reset-hasla"}
    },
    AUTHENTICATED: {
        HOME: {URL: "/"},
        MONITORY_NOTES: {
            MONITORY_NOTES_LIST: {URL: "/awizacje"},
            MONITORY_NOTE_CREATE: {URL: "/awizacje/utworz"},
            MONITORY_NOTE_DETAILS: {URL: "/awizacje/:monitoryNoteId"},
            // MONITORY_NOTE_SUBMIT: {URL: "/awizacje/utworz"},
            // MONITORY_NOTE_DELETE: {URL: "/awizacje/utworz"},
        },
        DISPOSITIONS: {
            DISPOSITION: {URL: "/dyspozycje/:terminalId/:dispositionId"},
            TERMINAL_DISPOSITIONS_LIST: {URL: "/dyspozycje/:terminalId"},
            DISPOSITIONS_TERMINALS_LIST: {URL: "/dyspozycje"}
        },
        PETROL_BASES: {
            PETROL_BASES_LIST: {URL: "/bazy-paliw"},
            PETROL_BASE: {URL: "/bazy-paliw/:petrolBaseId"}
        },
        SETTINGS: {
            MAIN_PAGE: {URL: "/ustawienia"},
            SETTINGS_USER_PAGE: {URL: "/ustawienia/profil"},
            SETTINGS_USER_DATA_PAGE: {URL: "/ustawienia/profil/moje-dane"},
            SETTINGS_MY_DOCUMENTS_PAGE: {URL: "/ustawienia/profil/moje-dokumenty"},
            SETTINGS_MY_BHP_PAGE: {
                MAIN_PAGE: {URL: "/ustawienia/profil/moje-szkolenia-bhp"},
                QUIZ: {
                    QUIZDESC: {URL: "/ustawienia/profil/moje-szkolenia-bhp/quiz"},
                    QUIZEXTRALINKS: {URL: "/ustawienia/profil/moje-szkolenia-bhp/quiz/extralinks"},
                    QUIZQUASTION: {URL: "/ustawienia/profil/moje-szkolenia-bhp/quiz/quastion"},
                    QUIZFINALIZATION: {URL: "/ustawienia/profil/moje-szkolenia-bhp/quiz/finalization"}
                }
            },
            SETTINGS_FINISHED_TRANSPORTS_PAGE: {URL: "/ustawienia/profil/moje-zakończone-transporty"},
            SETTINGS_MY_FAVORITE_PAGE: {URL: "/ustawienia/ulubione"},
            SETTINGS_MY_FAVORITE_VEHICLES_PAGE: {URL: "/ustawienia/ulubione/moje-ulubione-pojazdy"},
            SETTINGS_MY_FAVORITE_TERMINALS_PAGE: {URL: "/ustawienia/ulubione/moje-ulubione-bazy-paliw"},
            SETTINGS_ACCOUNT_PAGE: {URL: "/ustawienia/konto"},
            SETTINGS_DELETE_ACCOUNT_PAGE: {URL: "/ustawienia/konto/usuń-konto"},
            SETTINGS_CHANGE_PASSWORD_PAGE: {URL: "/ustawienia/konto/zmiana-hasla"},
            SETTINGS_DISCONNECT_FROM_OPERATOR_PAGE: {URL: "/ustawienia/konto/odlacz-od-przewoznika"},
            SETTINGS_INFORMATION_PAGE: {URL: "/ustawienia/informacje"},
            SETTINGS_REGULATIONS_PAGE: {URL: "/ustawienia/informacje/regulaminy"},
            SETTINGS_CONTACT_PAGE: {URL: "/ustawienia/informacje/kontakt"},
            SETTINGS_CONTACT_FORM_PAGE: {URL: "/ustawienia/informacje/kontakt/napisz-do-nas"},
            SETTINGS_ABOUT_PAGE: {URL: "/ustawienia/o-aplikacji"}
        },
        MESSAGES: {
            MESSAGES: {URL: "/wiadomosci"},
            MESSAGES_LIST: {URL: "/wiadomosci"},
            MESSAGE: {URL: "/wiadomosci/:messageId"},
        }
    },
    ERRORS: {
        E404: {URL: "/"}
    }
};


export default APPLICATION_ROUTER;
